import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// state
const state = {
  is_logged: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
